var _rect, _rect2, _rect3, _path, _path2, _ellipse, _ellipse2, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _rect9, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMittiIllustrationBeaver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.20689,
    height: 8.32758,
    rx: 1.60345,
    transform: "matrix(-1 0 0 1 11.8276 10.6724)",
    fill: "#E0A24A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7931,
    height: 4.60344,
    rx: 1.39655,
    transform: "matrix(-1 0 0 1 6.5 14.3965)",
    fill: "#CE8140"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.10281,
    height: 9.56043,
    rx: 2.5514,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 18.7069 9.98755)",
    fill: "#A26333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50877 3.00552C3.21629 2.49893 3.38986 1.85116 3.89645 1.55868V1.55868C4.40304 1.2662 5.05081 1.43977 5.34329 1.94636L5.48619 2.19387C5.56047 2.32253 5.51639 2.48704 5.38773 2.56132L4.01912 3.35149C3.89046 3.42577 3.72595 3.38169 3.65167 3.25303L3.50877 3.00552Z",
    fill: "#A26333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3621 7.18103C14.3621 3.76734 11.5947 1 8.18103 1V1C4.76734 1 2 3.76734 2 7.18103V13.4007C2 15.2362 3.48793 16.7241 5.32339 16.7241H11.0387C12.8741 16.7241 14.3621 15.2362 14.3621 13.4007V7.18103Z",
    fill: "#E0A24A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.465517,
    ry: 0.724137,
    transform: "matrix(-1 0 0 1 8.51724 6.48274)",
    fill: "#4E2609"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.465517,
    ry: 0.724137,
    transform: "matrix(-1 0 0 1 3.60345 6.48274)",
    fill: "#4E2609"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03448,
    height: 0.568965,
    rx: 0.284483,
    transform: "matrix(-1 0 0 1 9.03448 4.67242)",
    fill: "#A46434"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03448,
    height: 0.568965,
    rx: 0.284483,
    transform: "matrix(-1 0 0 1 3.96551 4.62067)",
    fill: "#A46434"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.827586,
    height: 1.18965,
    rx: 0.413793,
    transform: "matrix(-1 0 0 1 5.62069 7.98273)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 0.827586,
    height: 1.18965,
    rx: 0.413793,
    transform: "matrix(-1 0 0 1 6.60344 7.98273)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.03448,
    height: 1.44827,
    rx: 0.724137,
    transform: "matrix(-1 0 0 1 7.89655 6.94824)",
    fill: "#F9DDB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72413 7.36202C5.60057 7.36202 5.48544 7.32592 5.38872 7.26368C5.10044 7.07818 5.38134 6.74133 5.72413 6.74133C6.06693 6.74133 6.34783 7.07818 6.05955 7.26368C5.96283 7.32592 5.8477 7.36202 5.72413 7.36202Z",
    fill: "#A36330"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6.82758,
    height: 5.32758,
    rx: 2.66379,
    transform: "matrix(-1 0 0 1 9.29309 10.569)",
    fill: "#F9DDB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5587 3.35607C12.8976 2.769 12.6965 2.01832 12.1094 1.67938V1.67938C11.5224 1.34044 10.7717 1.54158 10.4327 2.12865L10.2671 2.41548C10.1811 2.56458 10.2321 2.75523 10.3812 2.84131L11.9673 3.757C12.1164 3.84308 12.307 3.792 12.3931 3.6429L12.5587 3.35607Z",
    fill: "#A26333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMittiIllustrationBeaver);
export default __webpack_public_path__ + "static/media/mitti-illustration-beaver.7cbe7e384b9755ad1562cd232a1cf917.svg";
export { ForwardRef as ReactComponent };